import './scroll-fadein.scss';

function ScrollFadeIn() {
  const fadeInElements = document.querySelectorAll('.fade-scroll');

  const isElementInViewport = (el) => {
    const rect = el.getBoundingClientRect();
    return rect.top >= 0 && rect.left >= 0 && rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) && rect.right <= (window.innerWidth || document.documentElement.clientWidth);
  };

  const handleScroll = () => {
    fadeInElements.forEach((el) => {
      if (isElementInViewport(el)) {
        el.classList.add('show');
      }
    });
  };

  window.addEventListener('scroll', handleScroll);
  handleScroll(); // ページロード時にも一度実行
}

ScrollFadeIn();
